import {
  CustomizationDataDto,
  TableConfigDto,
} from '@asset-metrix/portal-gateway-client-js';
import { TableCustomizationModalProps } from '@asset-metrix/portal-ui';

export function mergeCustomizationWithConfig(
  tableConfig: TableConfigDto,
  customizationData: CustomizationDataDto | null
): TableCustomizationModalProps['initialValue'] {
  const tableConfigColumnsWithOrder = tableConfig.columns
    .filter((col) => !col.hidden)
    .map((c, order) => ({
      ...c,
      order,
    }));

  const maxFixedIndex =
    tableConfigColumnsWithOrder.filter((c) => c.freeze).pop()?.order ?? -1;

  const customizations = tableConfigColumnsWithOrder
    .map((columnConfig) => {
      const customization = customizationData?.columns.find(
        (c) => c.columnId === columnConfig.id
      );

      const isGroupable =
        columnConfig.grouping != null || columnConfig.userGrouped;

      const customizationOverrides =
        customization != null
          ? {
              isVisible: customization.visible,
              fixed: customization.fixed,
              order: customizationData?.columns.indexOf(customization) ?? 0,
              // custom grouping will be only allowed if its enabled in poco column config.
              grouping: isGroupable ? customization.grouping : null,
            }
          : {};

      return {
        fixed: columnConfig.order <= maxFixedIndex,
        label: columnConfig.label,
        id: columnConfig.id,
        isVisible: !columnConfig.initiallyUnvisibleToUser,
        order: columnConfig.order,
        sublabel: columnConfig.sublabel,
        grouping: columnConfig.grouping,
        isGroupable,
        ...customizationOverrides,
      };
    })
    .sort((a, b) => a.order - b.order);

  return {
    groupedColumns: customizations
      .filter((c) => c.grouping != null)
      .sort((a, b) => Number(a.grouping) - Number(b.grouping)),
    fixedColumns: customizations.filter((c) => c.fixed && c.grouping == null),
    regularColumns: customizations.filter(
      (c) => !c.fixed && c.grouping == null
    ),
  };
}
